import { gql } from '@apollo/client';

export const GET_USER = gql`
  query getUser {
    user {
      firstname
      lastname
    }
    permissions {
      label
      settings {
        id
        name
        label
        value
      }
    }
  }
`;
